import { Link } from "react-router-dom";
import "../assets/styles/ToyotaCoopReport.scss";    

import goalOwnershipImage from '../assets/images/projectManagement.png';


import Toyota1 from "../assets/images/toyota-coop-report2.png";
import tmmc from "../assets/images/south-toyota-canada-plant2.jpeg";
import bastianAgv from "../assets/images/bastian-agv.png";
import toyotaProblemSolving from "../assets/images/Toyotas-8-step-problem-solving-process-Dunn-2016.png";
import softwareEngineeringImage from "../assets/images/https___dev-to-uploads.s3.amazonaws.com_uploads_articles_6ivh365bcmnn709zg6q0.webp"
import tmmcFactory from "../assets/images/tmmc-factory.jpg";
import tmmcCars from "../assets/images/tmmcCars.jpeg";

function ToyotaCoopReport() {
return(
        <div className="coop-report-container">
            <Link to="/" className="back-button">← Back to Portfolio</Link>
            
            <header className="report-header">
                <div className="company-logo">
                    <img src={Toyota1} alt="Toyota Logo" />
                </div>
                <h2 className="move-down">Work Term Report</h2>
                <h3>Software Engineering</h3>
                <div className="report-details">
                    <div className="detail-item">
                        <span className="detail-label">Program</span>
                        <span className="detail-value">Bachelor of Computing, Honors Co-op Computer Science</span>
                    </div>
                    <div className="detail-item">
                        <span className="detail-label">Company</span>
                        <span className="detail-value">Toyota</span>
                    </div>
                    <div className="detail-item">
                        <span className="detail-label">Term</span>
                        <span className="detail-value">Fall 2025</span>
                    </div>
                </div>
            </header>

            <div className="report-content">
                <section className="report-section">
                    <h3>Introduction</h3>
                    <div className="content-with-image">
                        <div className="text-content">
                            <p>
                                My second co-op work term took place at Toyota Motor Manufacturing Canada, where I worked as a systems software engineer, working on traffic control systems for Autonomous Guided Vehicles (AGVs) on the shop floor. 
                            </p>
                            <p>
                                This unique role enabled me to develop software that was directly utilized in the delivery of parts to and from various shop floors, supporting the production of the RAV4, Lexus RX, and Lexus NX.
                            </p>
                        </div>
                        <div className="image-content">
                            <img src={tmmcCars} alt="Combined Insurance Office" />
                        </div>
                    </div>
                </section>

                <section className="report-section">
                    <h3>About the Employer</h3>
                    
                    <h4>Company History & Background</h4>
                    <div className="content-with-image reverse">
                        <div className="text-content">
                            <p>
                                Toyota Motor Manufacturing Canada, or TMMC for short, was established in 1988 with the opening of the South Plant in Cambridge, Ontario, Canada. The North plant was opened in 1994, with the Woodstock facility subsequently announced in 2005. TMMC started building the Toyota Corolla, and has gone on to build the Camry Solara, and Matrix. Currently, TMMC builds the RAV4, Lexus RX and Lexus NX.
                            </p>
                            <p>
                                TMMC is globally recognized for its state-of-the-art manufacturing processes, robust safety culture, and high-quality plants. TMMC has been honoured to be one of Canada’s Top 100 Employers for 2025, as well as one of Canada’s Top Employers for Young People 2024. TMMC has also been awarded the Gold J.D. Power Plant Quality Award.
                            </p>
                        </div>
                        <div className="image-content">
                            <img src={tmmc} alt="Combined Insurance History" />
                        </div>
                    </div>

                    <h4>Mission & Customer Focus</h4>
                    <div className="full-width-content">
                        <p>
                            Toyota's main purpose is to provide mobility for all. Since beginning my work at Toyota, I’ve learned first-hand about the quality of engineering that Toyota offers to its customers. Operating in the automotive industry, which is known for its rigorous regulations and competition, Toyota has carved a reputation for extreme reliability and performance. 
                        </p>
                        <p>
                            This is due to the Toyota Business Practice culture, which relies on four pillars: genchi genbutsu, kaizen, muda and yokoten. Kaizen stands for continuous improvement, muda means minimizing waste, yokoten stands for horizontal implementation, and Genchi genbutsu describes the practice of how problems are broken down to their root cause and iteratively solved. Toyota uses these four pillars to compartmentalize every action into a process and deploy it efficiently for every relevant use, saving resources and minimizing waste.

                        </p>
                    </div>
                </section>

                <section className="report-section">
                    <h3>Job Description</h3>
                    
                    <h4>AGV Traffic Control Systems Team</h4>
                    <div className="content-with-image">
                        <div className="text-content">
                            <p>
                                During this co-op term, I was on the AGV Traffic Control Systems team. It’s a fleet management sandbox for autonomous guided vehicles, or AGVs for short. This software is used in Toyota Manufacturing plants across North America to ensure that the right parts ends up at the right factory shop at the right time, to ensure seamless production line workflow.
                            </p>
                        </div>
                        <div className="image-content">
                            <img src={bastianAgv} alt="Team Collaboration" />
                        </div>
                    </div>
                    
                    <div className="responsibilities-grid">
                        <h4>Key Responsibilities</h4>
                        <div className="responsibility-item">
                            <h5>Software Engineering</h5>
                        </div>
                        <p>In my role, I developed and deployed features for a Fleet Management Sandbox of Autonomous Guided Vehicles (AGVs)
                        using C# .NET, Angular, PrimeNG, PostgreSQL, Jenkins, Python, Pandas, SonarQube, Git, WSL, Linux and
                        Docker, improving fleet routing efficiency and reducing delivery delays on the production floor.</p>
                        <p>
                            These features included software components for visualizing AGV routes, data filtering logic, refactoring legacy code to pass Sonarqube security tests, researching regex patterns to refactor ones that are at risk of a DoS (Denial of Service) attack, and more.
                        </p>
                        
                        <div className="responsibility-item">
                            <h5>RFID Tag Reporting & Alert feature</h5>
                        </div>
                        <p>For my co-op project, I was tasked with solving a problem that the team members at the shop floor had when working with AGVs.
                            Agv's work by scanning RFID tags taped on the shop floor which tells the AGV instructions like when to stop, or speed up.
                            When these tags get damaged the AGV can miss an instruction. This can cause issues, such as not stopping at intersections, failing to dock
                            properly at parts transfer stations, and more, which can cascade into direct impact to the line.
                        </p>
                        <p>
                            To solve this problem, I went down to the shop floor to interview the team members experiencing tag-related issues with their Agvs. To analyze the shift notes, I developed a Python script that used the pandas library to parse and clean the data from the Shift notes on Excel.
                            Then I ran a pivot table on the cleaned data to identify how much time it was taken to fix tag-related issues, how many tag-related issues were reported per month, and which shop on the factory floor faced the most tag-related issues.
                        </p>
                        <p>
                                                        Based on this analysis, I found that there was an average of almost fifteen thousand minutes of team-member time and resources spent on intervening on tag-related issues per year. This is because the team member will have to manually
                            check each tag for damage, replace the tag, and then recalibrate the AGV to read the new tag. If the team member does not know which tag is damaged out of 5000 tags, this will take a lot of time to investigae, diagnose and fix.
                        </p>
                        <p>
                            To help the team members identify damaged tags more efficiently, I developed an RFID Tag Reporting & Alert feature that identifies potential damaged tags based on AGV error logs. 
                            This feature generates a report of tags that the AGV has missed, and shows an alert of a tag being missed more than a configured threshold, allowing team members to proactively inspect and replace these tags before they lead to operational disruptions.
                        </p>
                    </div>
                </section>

                <section className="report-section">
                    <h3>Goals & Objectives</h3>
                    
                    <p className="goals-intro">
                        I established several goals for this work term, combining measurable technical objectives with more subjective professional development targets. Each goal was strategically developed to align with job tasks and maximize my learning experience during this four-month term.
                    </p>

                    <div className="goal-reflection">
                        <h4>Goal 1: Project Ownership & Leadership</h4>
                    </div>
                    <div className="content-with-image">
                        <div className="text-content">
                            <p>
                                <strong>Objective:</strong> To own a specific area of different projects the Agv traffic Control Systems team and become a dependable player for my coworkers. This would provide me with greater responsibility and the ability to impact the organization while creating tangible value.
                            </p>
                            <p>
                                I developed this goal in relation to my job tasks, as the Agv traffic Control Systems team needed someone who could handle certain areas of work independently, allowing other team members to focus on their respective processes for different TMMC projects. 
                                To acheive this goal, I worked on my skill level on tools and technologies that are used in the AGV Fleet Management System, this included Typescript, Angular, C#, .NET, Docker, Linux.
                                I also made sure to show that I was reliable by properly understanding instructions and requirements, showcasing that I need minimal
                                supervision to complete my tasks effectively. Finally, I focused on understanding concepts above my responsibility, so that I can work on being assigned them. 
                            </p>
                        </div>
                        <div className="image-content">
                            <img src={goalOwnershipImage} alt="Project Ownership" />
                        </div>
                    </div>
                    
                    <div className="goal-reflection">
                        <h5>Reflection & Achievement</h5>
                        <p>
                            I believe I achieved this goal. I was entrusted to do higher priority work through my co-op TBP (Toyota Business Practice) project, and towards the second half of my term, where I was working with multiple stakeholders to refactor legacy code, fix bugs, and mitigate software security concerns using Sonarqube.
                        </p>
                    </div>

                    <div className="goal-reflection">
                        <h4>Goal 2: Advanced Software Systems Engineering</h4>
                    </div>
                    <div className="content-with-image reverse">
                        <div className="text-content">
                            <p>
                                <strong>Objective:</strong> To play a bigger role in the software systems engineering work at TMMC, particularly on projects that would lead to significant efficiency improvements and business impact.
                            </p>
                            <p>
                                I already had software engineering experience from previous internships, but I wanted to take it a step further by working on more complex systems that required a deeper understanding of software architecture, design patterns, and best practices.
                                This goal was motivated by my desire to enhance my technical skills and contribute meaningfully to the organization's success through impactful software solutions.
                            </p>
                            <p>
                                To achieve this goal, I deepened my understanding of our software tools, technologies, and architecutre by researching and experimenting in my free time.
                                I also sought feedback from senior engineers and participated in code reviews to learn from their expertise and improve my knowledge of software
                                engineering principles, design choices or techniques.
                            </p>
                        </div>
                        <div className="image-content">
                            <img src={softwareEngineeringImage} alt="Test Automation Goal" />
                        </div>
                    </div>

                    <div className="goal-reflection">
                        <h5>Reflection & Achievement</h5>
                        <p>
                            Although I did achieve this goal by learning more about the system architecture of our products, as well as the different use cases of Docker, Linux and Redis, the biggest lesson I learned is that good software engineering doesn't mean fancy tools and complicated designs, but simple yet effective solutions that need less maintenance, does not cause technical debt, and is easier to use and train others on.
                            This lesson allowed me to choose solutions not based on how impressive they sounded, but rather on what solution solved the problem most efficiently. This mindset change allowed me to comprehend and give better insight on advanced software engineering techniques, tradeoffs, and design choices. 
                        </p>
                    </div>

                    <div className="goal-reflection">
                        <h4>Goal 3: Adopting the Toyota Problem Solving Technique</h4>
                    </div>
                    <div className="content-with-image">
                        <div className="text-content">
                            <p>
                                <strong>Objective:</strong> To use the Toyota Problem Solving technique to approach and solve complex problems during my work term.
                            </p>
                            <p>
                                This goal was designed to enhance my problem-solving skills and align with Toyota's culture of continuous improvement and efficiency. The Toyota Problem Solving technique emphasizes a structured approach to identifying root causes, analyzing data, and implementing effective solutions.
                            </p>
                        </div>
                        <div className="image-content">
                            <img src={toyotaProblemSolving} alt="Project Management" />
                        </div>
                    </div>

                    <div className="agoal-reflection">
                        <h5>Reflection & Achievement</h5>
                        <p>
                            Through my role in the AGV Traffic Control Systems team, I had the opportunity to apply the Toyota Problem Solving technique on several occasions. 
                            One notable instance was when I identified inefficiencies in the RFID tag management process, which led to the development of an RFID Tag Reporting & Alert feature.
                        </p>
                        <p>
                            I practiced problem solving in a manufacturing environment, where I must solve a complicated problem with many layers and a time crunch. 
                            I also reached out for feedback from my manager and colleagues on how I can improve my problem solving approach and mindset.
                        </p>
                        <p>
                            	
                            I achieved this goal. I applied the Toyota problem solving technique whenever I came across a complicated problem, such as a complicated method that was hard to understand. 
                            I learned to break down the method code to find the root component from where it came from, 
                            I'd then find all components that used the method, and understand the relationship between all components, with this new understanding, I could diagnose faulty code in the method much more efficiently. 
                        </p>
                        <p>
                            I also applied the Toyota problem solving technique in my personal life, now whenever something is bothering me, I like to journal and ask myself why until I find the root cause and develop countermeasures. 
                            Now when I start a project, whether that be for school or work, I focus on breaking the project down to "stories" and using "story points" to estimat how long it should take me.
                            All my work is customer focused such that I focus on building the MVP (Minimum Viable Product) first, then iterating on feedback to improve the product.
                        </p>
                    </div>
                </section>

                <section className="report-section">
                    <h3>Impact & Results</h3>
                    
                    <div className="content-with-image reverse">
                        <div className="text-content">
                            <h4>Quantifiable Business Impact</h4>
                            <p>
                                My work on the RFID Tag Reporting & Alert feature is projected to save approximately <strong>15,000 minutes of team member time annually</strong> by proactively identifying and addressing damaged RFID tags before they lead to operational disruptions.
                                This efficiency gain allows team members to focus on higher-value tasks, enhancing overall productivity on the shop floor.
                            </p>
                            
                            <h4>Technical Achievements</h4>
                            <p>
                                The RFID Tag Reporting & Alert feature was successfully developed with plants to integrate into the AGV Fleet Management Sandbox, utilizing technologies such as C# .NET for backend development, Angular for frontend interfaces, and PostgreSQL for data management.
                            </p>
                            <p>
                                This feature comes with a dashboard for users to configure tag sequences, a reporting system that generates lists of potentially damaged tags based on AGV error logs, and an alert mechanism that notifies team members when a tag is missed beyond a set threshold by emailing them.
                            </p>
                        </div>
                        <div className="image-content">
                            <img src={tmmcFactory} alt="Business Impact" />
                        </div>
                    </div>
                </section>

                <section className="report-section">

                    <h3>Acknowledgements</h3>
                    <div className="full-width-content">
                        <p>
                            I would like to extend my gratitude to my team at TMMC, particularly my team lead, 
                            <strong> Katherine Leslie</strong>. Katie was instrumental in my development and growth 
                            throughout this work term, as she gave me a chance whenever an opportunity came up that aligned 
                            with my personal goals. Her support and mentorship allowed me to become experienced in both 
                            software engineering and non technical skills such as technical communication, Agile Project Management ideology, and more, which gave me the experience to 
                            qualify for future opportunities in work terms.
                        </p>
                        <p>
                            I'd also like to thank <strong>Sky Truong</strong>, <strong>Andrew Botsman</strong>, 
                            and the rest of my team as they were integral in supporting my work and mentoring me in software engineering.
                        </p>
                    </div>
                </section>

                <section className="report-section">
                    <h3>Conclusion</h3>
                    
                    <div className="full-width-content">
                        <h4>Exceeded Expectations</h4>
                        <p>
                            This work term exceeded my expectations in every way. I entered this co-op term never having experienced how software shapes the manufacturing process. 
                            This was by far the largest codebase that I had ever worked on, and I quickly learned that I had a lot to learn about working in a professional software engineering environment. 
                            The processes used in the AGV Traffic Control Systems team were unfamiliar, as everything was organized and process-oriented. 
                            For example, a design pattern I learned here was to have one abstract class that acted as the repository layer for a backend service. 
                            Then, different features needing a repository to connect to the database would need to implement this abstract class, allowing the developer to not rewrite existing logic. 
                            This was a prime example of Abstraction, Encapsulation, Inheritance, and Polymorphism. It feels rewarding to know that my work has a tangible impact on the production of Toyota vehicles. 
                            I feel proud to see Toyota RAV4s, Lexus RXs and NXs on the road, knowing that I played a part in their manufacturing process.
                        </p>

                        <h4>Personal Growth & Learning</h4>
                        <p>
                            This work term has been significant for my personal growth and learning. The biggest thing I learned is how much I don't actually know yet. There are vast amounts of design patterns, software architecture principles, and best practices that I was exposed to at TMMC, and I now know how much I don't know.
                        </p>
                        <p>
                            I also learned to value the basics. Pattern recognition, reading other people's code and understanding the tradeoffs of different designs are just as important as knowing a fancy tool. The best engineers are those who know how to learn new tools efficiently and use the fundamentals, instead of just looking at the next shiny thing.
                        </p>

                        <h4>Future Applications</h4>
                        <p>
                            My experience at TMMC has completely reshaped my perspective on software engineering, 
                            working in a fast-paced manufacturing environment where processes and efficiency were crucial for success. 
                            I am now someone who analyzes problems deeply and breaks them down to their root cause using the 
                            Toyota Problem Solving Technique (Genchi Genbutsu, Root Cause Analysis). I seek to understand everything 
                            about a system before I write code that impacts it. This includes testing a UI component to see its behaviour and reading documentation.
                            I focus on building software that is customer-centric, efficient, and simple to use. The way I approach building software is to deliver 
                            the MVP (Minimum Viable Product) first, then iterate on feedback to improve the product. Finally, I study a codebase and see how other 
                            features are built before I start building my own, ensuring I don't introduce technical debt and follow best practices. 
                            I will take these lessons with me to my next co-ops and benefit greatly from my experience at TMMC.

                        </p>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default ToyotaCoopReport;